import { useState } from "react";

interface IProps {
    started: boolean,
    ended: boolean
}

type badgeStatus = "recorded" | "in_progress" | "planed";

export const AccountRecordingItemStatusBadge = ({ started, ended }: IProps) => {
    const _getStatus = (): badgeStatus => {
        if (started && ended)
            return "recorded";
        else if (started && !ended)
            return "in_progress";
        else
            return "planed";
    }
    const [statusBadge] = useState<badgeStatus>(_getStatus());
    return (
        <p
            className={`mt-0.5 mb-2 md:mb-0 whitespace-nowrap rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset ${statusBadge === "recorded" && "text-green-500 ring-green-600/60"} ${statusBadge === "in_progress" && "text-red-500 ring-red-600/60"} ${statusBadge === "planed" && "text-blue-500 ring-blue-600/60"}`}
        >
            {statusBadge === "recorded" && "do odtworzenia"}
            {statusBadge === "in_progress" && "trwa nagrywanie"}
            {statusBadge === "planed" && "zaplanowane"}
        </p>
    )
}
